import { render } from "./MixBar.vue?vue&type=template&id=2460fb74"
import script from "./MixBar.vue?vue&type=script&lang=js"
export * from "./MixBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__